
export function setCookie(cname: string, cvalue: string, exdays: number, exhours?: number) {
  var d = new Date();

  if (exdays === 0) {
    if (exhours) {
      d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
    }
  } else {
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  }

  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname: string) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
